export { default } from '@/features/openTabs/pages/OpenTabsPage'
